import Axios from "axios";
import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import config from "../config.js";
import Cookies from "universal-cookie";
import mixpanel from "mixpanel-browser";
import { Box, Card, Typography, TextField, Button, Grid } from "@mui/material";

const CreateUserForm = ({ userToEdit, setUserToEdit }) => {
  const [form, setForm] = useState({
    username: "",
    fullname: "",
    email: "",
    contact: "",
    password: "",
    password1: "",
  });

  const cookies = new Cookies();
  const actionInitiatingUser = parseInt(cookies.get("userID")) || -1;
  const userToken = cookies.get("userToken") || "";

  useEffect(() => {
    if (userToEdit) {
      setForm({
        username: userToEdit.name || "",
        fullname: userToEdit.fullname || "",
        email: userToEdit.email || "",
        contact: userToEdit.contact || "",
        password: "",
        password1: "",
      });
    } else {
      setForm({
        username: "",
        fullname: "",
        email: "",
        contact: "",
        password: "",
        password1: "",
      });
    }
  }, [userToEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const Reset = () => {
    setForm({
      username: "",
      fullname: "",
      email: "",
      contact: "",
      password: "",
      password1: "",
    });
    setUserToEdit(null);
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    mixpanel.track("User Page Submit Button Clicked", {
      userID: cookies.get("userID"),
    });

    if (form.password !== form.password1) {
      swal("Password mismatch!", "Process failed.", "error");
      return;
    }

    const headers = {
      Authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json",
    };

    if (userToEdit) {
      Axios.put(
        `${config.BACKEND_URL}/users/${userToEdit.id}`,
        { ...form, actionInitiatingUser },
        { headers }
      ).then(() => {
        swal("User updated successfully!", "", "success").then(() =>
          window.location.reload()
        );
      });
    } else {
      Axios.post(
        config.BACKEND_URL + "/users",
        { ...form, actionInitiatingUser },
        { headers }
      ).then(() => {
        swal("User created successfully!", "", "success").then(() =>
          window.location.reload()
        );
      });
    }
  };

  return (
    <Box sx={{ maxWidth: 700, mx: "auto", mt: 4 }}>
      <Card sx={{ bgcolor: "#020617", border: "1px solid #1e293b", p: 3 }}>
        <Typography sx={{ color: "#e5e7eb", fontWeight: 600, mb: 2 }}>
          {userToEdit ? "Update User" : "Create User"}
        </Typography>

        <form onSubmit={formSubmit}>
          <Grid container spacing={2}>
            {Object.entries({
              username: "Username",
              fullname: "Full Name",
              email: "Email",
              contact: "Contact",
              password: "Password",
              password1: "Confirm Password",
            }).map(([key, label]) => (
              <Grid item xs={12} sm={6} key={key}>
                <TextField
                  fullWidth
                  type={key.includes("password") ? "password" : "text"}
                  label={label}
                  name={key}
                  value={form[key]}
                  onChange={handleChange}
                  required={!userToEdit || !key.includes("password")}
                  InputLabelProps={{ style: { color: "#9ca3af" } }}
                  sx={{
                    input: { color: "#e5e7eb" },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#1e293b" },
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>

          <Box
            sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" color="error" onClick={Reset}>
              Reset
            </Button>
            <Button variant="contained" type="submit">
              {userToEdit ? "Update" : "Submit"}
            </Button>
          </Box>
        </form>
      </Card>
    </Box>
  );
};

export default CreateUserForm;
